// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dialog[data-v-8ade0efe] .body {
  height: calc(var(--vh) * 65);
}
.contacts-list-modal[data-v-8ade0efe] {
  width: 100%;
  padding: 0px;
  display: flex;
  flex-direction: column;
}
`, "",{"version":3,"sources":["webpack://./js/app/components/modal/ContactsListModal.vue"],"names":[],"mappings":"AAAA;EACE,4BAA4B;AAC9B;AACA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB","sourcesContent":[".dialog[data-v-8ade0efe] .body {\n  height: calc(var(--vh) * 65);\n}\n.contacts-list-modal[data-v-8ade0efe] {\n  width: 100%;\n  padding: 0px;\n  display: flex;\n  flex-direction: column;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
